import React, { useState, useRef, useEffect } from "react";
import { Calendar, Instagram, Twitter, Facebook, X, LogOut } from 'lucide-react';
import Login from './Login';	

import {
  Editor,
  EditorProvider,
  Toolbar
} from "react-simple-wysiwyg";

import '../assets/style/index.css';

// Modal Component
// Modal Component
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0,0,0,0.6)', // fond semi-transparent
      zIndex: 50,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
	  fontSize: '14px',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#fff',
        color: '#032247',
        borderRadius: '12px',
        maxWidth: '800px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        padding: '20px',
		fontSize: '14px',
        position: 'relative'
      }}>
        <button onClick={onClose} style={{
          position: 'absolute',
          top: '15px',
          right: '15px',
          color: '#032247',
          fontSize: '14px',
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }}>
          ✖
        </button>
        {children}
      </div>
    </div>
  );
};


// Background Slider Component
const BackgroundSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    './ek3.jpg',
    './ek2.jpg',
	'./ek3.jpg'
	];

  useEffect(() => {
    const interval = setInterval(() => setCurrentSlide(prev => (prev + 1) % slides.length), 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100vh', zIndex: -10 }}>
      {slides.map((slide, index) => (
        <div key={index} style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${slide})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transition: 'opacity 1s',
		  
          opacity: index === currentSlide ? 1 : 0
        }} />
      ))}
      <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.4)' }}></div>
    </div>
  );
};

// Main Home Component
export default function Home() {
	function stripHtml(html) {
		  const tmp = document.createElement("div");
		  tmp.innerHTML = html;
		  return tmp.textContent || tmp.innerText || "";
		}
	
  // ✅ Récupération sûre de userData depuis localStorage
  const [userData, setUserData] = useState(() => {
    try {
      const saved = localStorage.getItem('userData');
      return saved ? JSON.parse(saved) : null;
    } catch (err) {
      console.error("Erreur parsing userData depuis localStorage:", err);
      localStorage.removeItem('userData');
      return null;
    }
  });
  const [requests, setRequests] = useState([]);
  const [steps, setSteps] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [types, setTypes] = useState([]);
  const [secteurs, setSecteurs] = useState([]);
  /*const [connaissance, setConnaissance] = useState([]);
  const [entreprise_lance, setEntreprise_lance] = useState([]);
  const [projet_avance, setProjet_avance] = useState([]);*/
  const [services, setServices] = useState([]);
  const [formData, setFormData] = useState({
  type:'', objet:'', comment:'', secteur:'', userID: '',connaissance : '', entreprise_lance :'', projet_avance:'', email:''
});
  const rowColors = ["#03247", "#3c3d5e"];
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  // State pour modal et demandes
  const [showRequestsModal, setShowRequestsModal] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [newMessage, setNewMessage] = useState("");
  const [fullDescription, setFullDescription] = useState("");
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  // Pour la loupe (titre + description)
const [showModal, setShowModal] = useState(false);
const [modalText, setModalText] = useState("");


  const truncate = (text, max = 20) => {
	  if (!text) return "";
	  return text.length > max ? text.substring(0, max) + "..." : text;
	};

  const detailRef = useRef(null);
  // Déconnexion
  const handleLogout = () => {
    localStorage.removeItem('userData');
    setUserData(null);
  };

  const handleInputChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
	//affiche chat
	const DisplayChat = async (userID, projectId) => {
  setCurrentProjectId(projectId);
  setShowChatModal(true);
  try {
    const res = await fetch(`https://ekapi.bblconcept.com/getData.php?action=getChat&userID=${userID}&pr=${projectId}`);
    const data = await res.json();
    if (data.success) {
      // Normaliser pour s'assurer que chaque message a un tableau reponses
      const normalized = data.messages.map(msg => ({
        ...msg,
        reponses: msg.reponses || (msg.reponse ? [{ message: msg.reponse, date_reponse: msg.date_reponse }] : [])
      }));
      setChatMessages(normalized);
    } else {
      setChatMessages([]);
    }
  } catch (err) {
    console.error("Erreur fetch chat:", err);
    setChatMessages([]);
  }
};
// Fonction pour envoyer un message
const sendMessage = async () => {
  if (!newMessage.trim()) return;

  try {
    const res = await fetch(`https://ekapi.bblconcept.com/sendChat.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        project_id: currentProjectId,
        message: newMessage,
        userID: userData.id
      }),
    });

    const data = await res.json();
    console.log("Réponse API :", data); // DEBUG

    if (data.success) {
      // Ajouter le message localement
      setChatMessages(prev => [
        ...prev,
        {
          user: userData.username,
          message: newMessage,
          created_at: new Date().toISOString()
        }
      ]);

      // Vider l’input
      setNewMessage("");  // <-- OBLIGATOIREMENT lié à l’input
    }

  } catch (err) {
    console.error("Erreur envoi message:", err);
  }
};

	//annuler une demande 
	const handleCancelRequest = async (id) => {
   if (!window.confirm(`Voulez-vous vraiment annuler la demande #EK00-${id} ?`)) return;

  try {
    const res = await fetch("https://ekapi.bblconcept.com/cancelRequest.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    const data = await res.json();

    if (data.success) {
      setRequests(prev => prev.map(r => 
        r.id === id ? { ...r, status_name: 'Annulé' } : r
      ));
      alert("Demande annulée avec succès ✅");
    } else {
      alert("Erreur : " + data.message);
    }
  } catch (err) {
    console.error("Erreur réseau:", err);
    alert("Impossible d’annuler la demande.");
  }
};
  useEffect(() => {
  fetchRequests();
}, [userData]); // [] signifie que ça s'exécute une seule fois au montage du composant

// Fonction pour charger les demandes
const fetchRequests = async () => {
  if (!userData) return;
  try {
    const params = new URLSearchParams({
      user_id: userData.id,
      email: userData.email
    });
    const res = await fetch(`https://ekapi.bblconcept.com/getRequests.php?user_id=${userData.id}`);
    const data = await res.json();
	//console.log('fetch result raw:', data);
    // Vérifie que c’est un tableau

		setRequests(Array.isArray(data.data) ? data.data : []);
	    setSteps(data.steps); // stocke les étapes
  } catch (err) {
    console.error('Erreur fetch requests:', err);
    setRequests([]);
  }
};

  // Charger les types de demande
  useEffect(() => {
    fetch('https://ekapi.bblconcept.com/getData.php?action=getTypes')
      .then(res=>res.json())
      .then(data=>{
        if(!data.error) setTypes(data);
      })
      .catch(err=>console.error('Erreur réseau:',err));
  }, []);
  
    useEffect(() => {
    fetch('https://ekapi.bblconcept.com/getData.php?action=getSecteurs')
      .then(res=>res.json())
      .then(data=>{
        if(!data.error) setSecteurs(data);
      })
      .catch(err=>console.error('Erreur réseau:',err));
  }, []);
const handleServiceSubmit = async () => {
  // Vérification des champs obligatoires
  if (!formData.type || !formData.objet || !formData.secteur || !formData.comment || !formData.connaissance || !formData.entreprise_lance || !formData.projet_avance) {
    setMessage('Erreur : Veuillez remplir tous les champs obligatoires.');
    setTimeout(() => setMessage(''), 4000);
    return;
  }

  setIsSubmitting(true);
  setMessage('');

  try {
    // Préparation des données à envoyer
    const payload = {
	  user_id: userData.id,
      email: userData.email,
      type: formData.type,
      objet: formData.objet,
	  secteur : formData.secteur,
	  connaissance : formData.connaissance,
	  entreprise_lance : formData.entreprise_lance,
	  projet_avance : formData.projet_avance,
      comment: formData.comment
    };

    // Envoi vers l'API
    const response = await fetch('https://ekapi.bblconcept.com/action_request.php?action=insert', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (data.success) {
      setMessage('✅ Votre projet a été enregistré avec succès !');
      // Réinitialiser le formulaire
      setFormData({
        type: '',
        objet: '',
        comment: ''
      });
      // Facultatif : fermer le modal après succès
      // setShowRequestsModal(false);
    } else {
      setMessage('Erreur : ' + (data.error || 'Impossible d’enregistrer le projet.'));
    }
  } catch (err) {
    console.error(err);
    setMessage('Erreur réseau : Impossible d’enregistrer le projet.');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setMessage(''), 5000);
  }
};


  // 🔹 Si pas connecté, afficher Login
  if (!userData) {
    return <Login onLoginSuccess={(data) => {
      setUserData(data);
      localStorage.setItem('userData', JSON.stringify(data));
    }} />;
  }


  return (
    <div style={{ minHeight: '100vh', color: 'white', position: 'relative', fontFamily: 'Arial, sans-serif' }}>
      <BackgroundSlider />

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
        <div style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '20px', position: 'relative' }}>
          <img src="logo.png" className="logo" alt="Logo" />
          <LogOut size={28} style={{ position: 'absolute', right: 0, top: '20px', cursor: 'pointer', color: 'white' }} onClick={handleLogout} title="Déconnexion" />
        
		<button
			  onClick={() => {
				setShowRequestsModal(true);
			  }}
			  style={{
				  position: 'absolute',
				  top: '20px',
				  right: 40,
				  padding: '10px 20px',
				  borderRadius: '8px',
				  backgroundColor: '#03224C',
				  color: 'white',
				  border: 'none',
				  cursor: 'pointer',
				  fontWeight: 'bold',
				  fontSize:'14px'
				}}
			 > Créer une demande
			</button>
			
			{showChatModal && (
			  <Modal isOpen={showChatModal} onClose={() => setShowChatModal(false)}>
				<h3 style={{ color: '#fff' }}>Chat du projet EK00-{currentProjectId}</h3>
				<div style={{ maxHeight: '400px', overflowY: 'auto', backgroundColor: '#032247', padding: '10px', borderRadius: '8px' }}>
				  {chatMessages.length === 0 ? (
					  <p>Aucun message pour ce projet.</p>
					) : (
					  <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '10px' }}>
						{chatMessages.map(demande => (
						  <div key={demande.id_demande} style={{ marginBottom: '20px' }}>
							{/* Entête demande */}
							<div style={{ backgroundColor: '#032247', color: 'white', padding: '10px', borderRadius: '8px' }}>
							  <strong>{demande.objet}</strong>
							  <div style={{ fontSize: '12px', color: '#ccc' }}>{demande.date_question}</div>
							  <div style={{ marginTop: '5px' }}>{demande.message}</div>
							</div>

							{/* Réponses associées */}
							{(demande.reponses || []).map((rep, idx) => (
							  <div
								key={idx}
								style={{
								  backgroundColor: '#0A3247',
								  color: 'white',
								  padding: '8px 12px',
								  borderRadius: '12px',
								  marginTop: '6px',
								  marginLeft: '20px', // léger décalage pour les réponses
								  fontSize: '14px'
								}}
							  >
								{rep.message}
								<div style={{ fontSize: '11px', color: '#ccc', marginTop: '2px' }}>
								  {rep.date_reponse}
								</div>
							  </div>
							))}
						  </div>
						))}
					  </div>
					)}


				</div>
				<div style={{ marginTop: '10px', display: 'flex', gap: '5px' }}>
				  <input
					value={newMessage}
					onChange={e => setNewMessage(e.target.value)}
					style={{ flex: 1, padding: '8px', borderRadius: '6px', border: '1px solid #ccc' }}
					placeholder="Votre message..."
				  />
				  <button onClick={sendMessage} style={{ padding: '8px 12px', borderRadius: '6px', backgroundColor: '#0A3247', color: 'white', border: 'none' }}>
					Envoyer
				  </button>
				</div>
			  </Modal>
			)}

			 {/* Modal */}
			  <Modal isOpen={showRequestsModal} onClose={() => {
				  setShowRequestsModal(false);
				  fetchRequests();   // ⬅ refresh du tableau
				}}>
				<h2 style={{ color: 'white', marginBottom: '20px', fontSize: '28px' }}>
					{userData.username},
				</h2>
				 <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: 'rgba(255,255,255,0.1)', padding: '20px', borderRadius: '12px' }}>
				  <h3 style={{ textAlign: 'center', fontSize: '24px', marginBottom: '20px' }}>Enregistrer un projet</h3>
				<label>Type de demande</label>
				  <select name="type" value={formData.type} onChange={handleInputChange} style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '8px', border: '1px solid #ccc' }}>
					<option value="">Sélectionner un type</option>
					{types.map(s => <option key={s.id_type} value={s.id_type}>{s.type}</option>)}
				  </select>

				  <label>Objet / Nom du Projet</label>
				  <input type="text" name="objet" value={formData.objet} onChange={handleInputChange} style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '8px', border: '1px solid #ccc' }} />
				<label>Secteur d'activité</label>				
				<select name="secteur" value={formData.secteur} onChange={handleInputChange} style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '8px', border: '1px solid #ccc' }}>
					<option value="">Sélectionner un secteur d'activité</option>
					{secteurs.map(t => <option key={t.secteur} value={t.secteur}>{t.secteur}</option>)}
				  </select>
				<label>Avez-vous des connaissance dans le domaine ?</label>				
				<select name="connaissance" value={formData.connaissance} onChange={handleInputChange} style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '8px', border: '1px solid #ccc' }}>
					<option value=""></option>
					<option value="Oui">Oui</option>
					<option value="Non">Non</option>
				  </select>
				  <label>Avez-vous déjà lancé une entreprise ?</label>				
				<select name="entreprise_lance" value={formData.entreprise_lance} onChange={handleInputChange} style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '8px', border: '1px solid #ccc' }}>
					<option value=""></option>
					<option value="Oui">Oui</option>
					<option value="Non">Non</option>
				  </select>
				  <label>Votre projet est il démarré ?</label>	
				 <select name="projet_avance" value={formData.projet_avance} onChange={handleInputChange} style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '8px', border: '1px solid #ccc' }}>
					<option value=""></option>
					<option value="Oui">Oui</option>
					<option value="Non">Non</option>
				  </select>
				 <label>Description du Projet</label>
					<EditorProvider>
					  <Toolbar className="simple-wysiwyg-toolbar" />
					  <Editor
						value={formData.comment}
						onChange={(e) =>
						  setFormData({ ...formData, comment: e.target.value })
						}
						
					  />
					</EditorProvider>


				  <button onClick={handleServiceSubmit} disabled={isSubmitting} style={{ padding: '12px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', backgroundColor: '#0A3247', color: 'white', fontWeight: 'bold', width: '100%' }}>
					{isSubmitting ? 'Envoi en cours...' : 'Envoyer la demande'}
				  </button>

				  {message && <div style={{ textAlign: 'center', marginTop: '10px', color: message.toLowerCase().includes('erreur') ? 'red' : 'green', fontWeight: 'bold' }}>{message}</div>}
				</div>
			  </Modal>
		</div>

        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ fontSize: '48px', marginBottom: '10px' }}>Bonjour {userData.username} 👋</h1>
          <h2 style={{ fontSize: '36px', marginBottom: '10px' }}>Bienvenu dans votre espace</h2>
		  
		  {requests.length === 0 ? (
				  <p>Aucune demande en cours.</p>
				) : (
				  <div style={{ overflowX: 'auto', marginTop: '20px' }}>
				  
 <table
  style={{
    width: '100%',
    borderCollapse: 'collapse',
    color: 'white',
    fontSize: '14px',
    backgroundColor: '#032247',
    minWidth: '700px'
  }}
>
  <thead>
    <tr style={{ backgroundColor: '#fff', color:'#032247'}}>
      <th style={{ borderBottom: '1px solid white', padding: '8px' }}>ID Demande</th>
      <th style={{ borderBottom: '1px solid white', padding: '8px' }}>Type de demande</th>
      <th style={{ borderBottom: '1px solid white', padding: '8px' }}>Titre</th>
      <th style={{ borderBottom: '1px solid white', padding: '8px' }}>Description</th>
      <th style={{ borderBottom: '1px solid white', padding: '8px' }}>Date de demande</th>
      <th style={{ borderBottom: '1px solid white', padding: '8px' }}>Statut</th>
      <th style={{ borderBottom: '1px solid white', padding: '8px' }}>Action</th>
      <th style={{ borderBottom: '1px solid white', padding: '8px' }}>Conversation</th>
    </tr>
  </thead>

  <tbody>
    {requests.map((req,index) => (
      <tr 
        key={req.id}
        style={{
          cursor: 'pointer',
          backgroundColor:
            selectedRequest?.id === req.id
              ? '#1a2a4c'
              : rowColors[index % rowColors.length],
          transition: "0.2s"
        }}
        onClick={() => {
          setSelectedRequest(req);
          setTimeout(() => {
            detailRef.current?.scrollIntoView({ behavior: "smooth" });
          }, 100);
        }}
      >
        <td style={{ borderBottom: '1px solid white', padding: '8px', textAlign: 'center' }}>
          EK00-{req.id}
        </td>

        <td style={{ borderBottom: '1px solid white', padding: '8px', textAlign: 'center' }}>
          {req.type}
        </td>

        {/* TITRE TRONQUÉ + LOUPE */}
        <td style={{ borderBottom: '1px solid white', padding: '8px', textAlign: 'center' }}>
          {req.title.length > 20 ? req.title.substring(0, 20) + "..." : req.title}

          <span
            onClick={(e) => {
              e.stopPropagation();
              setModalText(req.title);
              setShowModal(true);
            }}
            style={{ cursor: "pointer", marginLeft: "8px", fontSize: "16px" }}
          >
            🔍
          </span>
        </td>

        {/* DESCRIPTION TRONQUÉE + LOUPE */}
        <td style={{ borderBottom: '1px solid white', padding: '8px', textAlign: 'center' }}>
          {req.description.length > 20 ? stripHtml(req.description).substring(0, 20) + "..." : stripHtml(req.description)}

          <span
            onClick={(e) => {
              e.stopPropagation(); 
              setModalText(stripHtml(req.description));
              setShowModal(true);
            }}
            style={{ cursor: "pointer", marginLeft: "8px", fontSize: "16px" }}
          >
            🔍
          </span>
        </td>

        <td style={{ borderBottom: '1px solid white', padding: '8px', textAlign: 'center' }}>
          {req.created_at}
        </td>

        <td style={{ borderBottom: '1px solid white', padding: '8px', textAlign: 'center' }}>
          {req.status_name}
        </td>

        <td style={{ borderBottom: '1px solid white', padding: '8px', textAlign: 'center' }}>
          {req.status_name === 'Soumis' ? (
            <button
              onClick={() => handleCancelRequest(req.id)}
              style={{
                backgroundColor: 'orange',
                color: 'white',
                border: 'none',
                padding: '6px 10px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '11px',
              }}
            >
              Annuler
            </button>
          ) : (
            <span style={{ color: '#aaa' }}></span>
          )}
        </td>

        <td style={{ borderBottom: '1px solid white', padding: '8px', textAlign: 'center' }}>
          <button
            onClick={() => DisplayChat(userData.id, req.id)}
            style={{
              backgroundColor: 'white',
              color: 'white',
              border: 'none',
              padding: '6px 10px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '11px',
            }}
          >
            🗣️
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>


  {selectedRequest && (
	  <div  ref={detailRef} style={{ marginTop: '20px', backgroundColor:'#fff', color:'#032247', align:'center' }}>
		<h3>Suivi de la demande EK00-{selectedRequest.id}</h3>

		<div style={{
		  display: 'flex',
		  maxWidth: '600px',
		  justifyContent: 'center', // centrage horizontal
		  alignItems: 'center',
		  gap: '15px', // espace entre les étapes
		  flexWrap: 'wrap' // responsive → les étapes se déplacent si l'écran est petit
			}}>
		   {steps
        .filter(step => {
          // Si la demande n'est pas annulée, on supprime l'étape "Annulé"
          return !(selectedRequest.status_name !== "Annulé" && step.status_name === "Annulé");
        })
        .map((step) => {

        const requestCancelled = selectedRequest.status_name === "Annulé";
        const isCancelledStep = step.status_name === "Annulé";

        // === ETAT ACTIF / NON ACTIF ===
        let bgColor = "#0af3"; // par défaut : futur
		let iconToDisplay = step.icon; // icône venant de la base
        if (requestCancelled) {
          // Demande annulée → tout gris
          bgColor = "#b0b0b0";
        } else {
          if (step.id_status < selectedRequest.id_status) {
            bgColor = "#3CB371"; // ✔️ Étapes déjà VALIDÉES → vert
          } else if (step.id_status === selectedRequest.id_status && !isCancelledStep) {
            bgColor = "#032247"; // ✔️ Étape actuelle → bleu clair
          }
		// === ICÔNE À AFFICHER ===
         
          // Étape "Annulé" → toujours grise quand la demande n'est pas annulée
          if (isCancelledStep) {
            bgColor = "#b0b0b0";
			iconToDisplay = "✖";
          }
        }
		
        if (isCancelledStep && requestCancelled) {
          iconToDisplay = "❌"; // Demande annulée → croix rouge
		   bgColor = "red";
        }

        return (
          <div key={step.id_status} style={{ textAlign: 'center', flex: 1, justifyContent: 'center' }}>
            <div style={{
              width: '50px',
              height: '50px',
              borderRadius: '100%',
              backgroundColor: bgColor,
              margin: '0 auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '26px',
			  color: 'white'
            }}>
              {iconToDisplay}
            </div>

            <div style={{ fontSize: '12px', marginTop: '5px' }}>
              {step.status_name}
            </div>
			
			    
			
          </div>
        );
      })}
    </div>
	<div style={{ marginTop:'20px', textAlign:'left', color:'#032247', backgroundColor:'#f0f0f0', padding:'10px', borderRadius:'8px' }}>
	  <h4>Score projet :</h4>
	  <p>Maturité : {selectedRequest.maturite}/10</p>
	  <p>Impact : {selectedRequest.impact}/10</p>
	  <p>Faisabilité : {selectedRequest.faisabilite}/10</p>
	  <p>Score global : {selectedRequest.score_global}/10</p>
	  <p>Recommandations : {Array.isArray(selectedRequest.recommandations) ? selectedRequest.recommandations.join(', ') : selectedRequest.recommandations}</p>
	</div>
  </div>
  
)}
{/* MODAL DE VISUALISATION */}
{showModal && (
  <div style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999
  }}
    onClick={() => setShowModal(false)}
  >
    <div
      style={{
        background: "white",
        padding: "20px",
        borderRadius: "10px",
        width: "400px",
        maxHeight: "70vh",
        overflowY: "auto",
        color: "#032247",
        boxShadow: "0 0 20px rgba(0,0,0,0.2)"
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <h3 style={{ marginBottom: "10px", fontSize: "18px" }}>
        🔍 Aperçu complet
      </h3>
      <p style={{ whiteSpace: "pre-wrap" }}>{modalText}</p>

      <button
        onClick={() => setShowModal(false)}
        style={{
          marginTop: "15px",
          background: "#032247",
          color: "white",
          padding: "8px 15px",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer"
        }}
      >
        Fermer
      </button>
    </div>
  </div>
)}



</div>

)}


        </div>

       
      </div>
	  <footer
  style={{
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    backgroundColor: "#0A3247",
    color: "white",
    textAlign: "center",
    padding: "10px 0",
    fontSize: "14px",
    zIndex: 9999,
    boxShadow: "0 -2px 5px rgba(0,0,0,0.2)"
  }}
>
  © {new Date().getFullYear()} Empreinte Kapital — Tous droits réservés
</footer>

    </div>
  );
}
